module.exports = __webpack_public_path__ + "static/media/ic_userGuide_pathway_game.ddb6f994.png";